import { JobsService } from 'app/API';
import type { TWorkspaceJobsListParams } from 'app/queries/jobs/jobsKeys';

export const requestWorkspaceJobs = (workspaceId: string, params: TWorkspaceJobsListParams) => {
  const request = {
    wsid: workspaceId,
    pageNo: String(params.page),
    pageSize: String(params.pageSize),
    orderBy: params.orderBy,
    orderType: params.orderType,
    search: params.search,
    from: params.from,
    to: params.to,
  };
  return params.tab === 'assigned'
    ? JobsService.getMyJobs(request)
    : JobsService.getWsJobs({ ...request, status: params.status });
};
